module.exports = __webpack_public_path__ + "static/media/logo.159bdaf6.png";